import React from "react"
import Header from "../components/header"
import Footer from "../components/footer"
import ContactForm from "../components/contactForm"
import "../styles/styles.sass"
import SEO from "../components/seo"

const ContactPage = props => (
  <div className="landingView contactView">
    <SEO
      title={"CueHit - Contact"}
    />

    <Header />

    <div className="landingContent">    
      <ContactForm />
    </div>

    <Footer/>
  </div>
)

export default ContactPage